module.exports = __webpack_public_path__ + "static/img/3.493f1f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Chengtun/3.jpg
// module id = x8Ym
// module chunks = 0